import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Fatture',
  form: {
    title: 'Richiedi nuovo pagamento',
    company: {
      label: 'Ristorante',
    },
    billing_mode: {
      label: 'Fonte di fatturazione',
    },
    billing_anchor: {
      label: 'Inizia fatturazione il',
    },
    items: {
      label: 'Voci',
    },
    name: {
      label: 'Nome',
      placeholder: '1000x Volantini',
    },
    net_amount: {
      label: 'Importo (NETTO)',
      tax_breakdown: '+{{tax}} IVA = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Ristorante',
    name: 'Nome/Numero',
    billing_mode: 'Fonte di fatturazione',
    type: 'Tipo',
    status: 'Stato',
    amount: 'Importo (Lordo)',
    created_at: 'Creata',
    billing_anchor: 'Fatturazione dal',
    invoice: 'Fattura',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Metodo di pagamento',
    [BillingMode.InternalInvoicing]: 'Vendite',
  },
  types: {
    [InvoiceType.Manual]: 'Manuale',
    [InvoiceType.SetupFee]: 'Costo di attivazione',
    [InvoiceType.Subscription]: 'Abbonamento',
    [InvoiceType.SubscriptionBridge]: 'Abbonamento (proporzionale fino al 5)',
    [InvoiceType.SubscriptionProration]: 'Abbonamento (upgrade proporzionale)',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'In attesa',
    [InvoiceStatus.Processing]: 'In elaborazione',
    [InvoiceStatus.Paid]: 'Pagata',
    [InvoiceStatus.PartiallyRefunded]: 'Parzialmente rimborsata',
    [InvoiceStatus.Refunded]: 'Rimborsata',
    [InvoiceStatus.Failed]: 'Fallita',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Sei sicuro di voler creare una fattura di {{amount}} NETTO a {{company}} tramite {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Sei sicuro?',
      description:
        '<strong>{{company}}</strong> verrà addebitato <strong>{{amount}} lordo + penale per mancato pagamento se applicabile</strong> dal metodo di pagamento principale per la fattura {{details}}',
      recharge_failed: {
        title: 'Stripe ha rifiutato il pagamento',
        convert_hint:
          "Puoi riscuotere questa fattura dalle vendite del ristorante. La fattura Stripe verrà annullata e l'importo dovuto verrà detratto dai prossimi pagamenti.",
      },
    },
  },
  buttons: {
    show_transfers: 'Mostra trasferimenti',
    hide_transfers: 'Nascondi trasferimenti',
    create: 'Crea',
    download_pdf: 'Scarica PDF',
    open_payment_page: 'Apri pagina di pagamento',
    open_invoice_page: 'Apri dettagli fattura',
    add_item: 'Aggiungi voce',
    convert_to_internal_billing: 'Riscuoti dalle vendite',
    recharge_invoice: 'Riaddebita fattura',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_create_invoice: 'Creazione fattura non riuscita!',
    invoice_got_created: 'Fattura creata!',
    invoice_got_recharged: 'Fattura riaddebita. Nuovo pagamento in elaborazione!',
    failed_to_recharge_invoice: 'Riaddebbito fattura non riuscito!',
    invoice_got_converted_to_internal_billing:
      "Fattura convertita a fatturazione vendite. L'importo dovuto verrà detratto dai prossimi pagamenti.",
    failed_to_convert_invoice_to_internal_billing: 'Conversione fattura a fatturazione vendite non riuscita!',
  },
};
